import React from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FullOrganization } from "@/contexts/SelectedAccountContext";

interface Props {
  companies: FullOrganization[];
  selectedCompany: FullOrganization | null;
  selectedAccountId: string | null;
  setSelectedOrganizationId: (id: string | null) => void;
}

const CompanySelector: React.FC<Props> = ({
  companies,
  selectedCompany,
  selectedAccountId,
  setSelectedOrganizationId,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  // Only render when there is more than one organization to choose from
  if (!companies || companies.length <= 1) return null;
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const selectedCompanyName = selectedCompany?.name ?? "Select Company";

  return (
    <>
      <Button
        id="company-menu-button"
        aria-controls={open ? "company-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        aria-label={selectedCompanyName}
        onClick={handleOpen}
        sx={{
          textTransform: "none",
          minWidth: "auto",
          padding: "8px",
          marginRight: "12px",
        }}
      >
        {selectedCompanyName}

        <ArrowDropDownIcon
          sx={{ verticalAlign: "middle", ml: 0.5 }}
          aria-hidden="true"
        />
      </Button>

      <Menu
        id="company-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{ list: { "aria-labelledby": "company-menu-button" } }}
      >
        {companies.map((c) => (
          <MenuItem
            key={c.id}
            onClick={() => {
              setSelectedOrganizationId(c.id);
              handleClose();
            }}
            selected={c.id === selectedAccountId}
          >
            {c.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default CompanySelector;
